export const camsLoginEn = {
  'camslogin-title': 'Cardholder Login',
  'camslogin-subtitle':
    'To access your card balance or to activate your card, please provide the following information.',
  'camslogin-cardnumber-label': 'ENTER 16 DIGIT NUMBER',
  'camslogin-cardnumber-placeholder': 'Card Number',
  'camslogin-cvv-label': 'ENTER CVV',
  'camslogin-cvv-placeholder': 'CVV',
  'camslogin-accesscode-label': 'ENTER ACCESS CODE',
  'camslogin-accesscode-placeholder': 'Access Code',
  'camslogin-submit_title': 'GO',
  'camslogin-cardnumber-errormsg': 'Please enter a valid 16-digit card number',
  'camslogin-cvv-errormsg': 'Please enter a valid CVV',
  'camslogin-accesscode-errormsg': 'Please enter a valid access code',
  'camslogin-invalid-credentials-error':
    'Invalid card credentials. Please check your information and try again.',
  'camslogin-card-not-found-error':
    'Card not found. Please verify your card number.',
  'camslogin-invalid-card-error':
    'Card not found. Please verify your card number.',
  'camslogin-invalid-cvv-error':
    'Invalid CVV. Please check and try again.',
  'camslogin-invalid-accesscode-error':
    'Invalid access code. Please check and try again.',
  'camslogin-cams-disabled-error':
    'This login method is not available for your card. Please contact support.',
  'camslogin-already-registered-error':
    'This card is already registered with username based login. Please use your username and password to login.',
  'camslogin-cvv-helpertext': 'The 3-digit Security Code is the number printed flat on the right side of the signature panel on the back of your card. We ask for this number as a security precaution.',
  'camslogin-accesscode-helpertext': 'The Access Code is the 4-digit number printed at the top right corner on the letter on which your card is attached.',
  'camslogin-accesscode-help-link': 'Don\'t have an Access Code? Click here',
  'camslogin-privacydescription':
    'Your privacy and security are our top priorities. Keep your card details confidential to prevent unauthorized access.',
  'camslogin-register-heading': 'Create Your Account',
  'camslogin-register-subtitle':
    'To continue using this portal, please register with a username and password. This will make future logins easier and more secure.',
  'camslogin-register-button': 'Register Now',
  'camslogin-skip-button': 'Skip for Now',
  'camslogin-register-username-label': 'Username',
  'camslogin-register-username-placeholder': 'Enter username',
  'camslogin-register-password-label': 'Password',
  'camslogin-register-password-placeholder': 'Enter password',
  'camslogin-register-confirmpassword-label': 'Confirm Password',
  'camslogin-register-confirmpassword-placeholder': 'Confirm your password',
  'camslogin-register-success': 'Account created successfully! You can now login with your username and password.',
  'camslogin-knowledge-base': 'Knowledge Base',
  'camslogin-already-have-account': 'Already have a username? Login here',
  'camslogin-back-button': 'Back',
  // CAMS Register
  'camsregister-title': 'Create Your Account',
  'camsregister-subtitle': 'To continue using this portal, please register with a username and password. This will make future logins easier and more secure.',
  'camsregister-email-label': 'EMAIL ADDRESS',
  'camsregister-email-placeholder': 'Enter your email',
  'camsregister-username-label': 'USERNAME',
  'camsregister-username-placeholder': 'Enter username',
  'camsregister-password-label': 'PASSWORD',
  'camsregister-password-placeholder': 'Enter password',
  'camsregister-passwordconfirm-label': 'CONFIRM PASSWORD',
  'camsregister-passwordconfirm-placeholder': 'Confirm your password',
  'camsregister-submit-button': 'Register',
  'camsregister-login-link': 'Already have a username? Login here',
  'camsregister-username-required': 'Username is required',
  'camsregister-username-invalid': 'Username must be 3-30 characters with letters, numbers, and underscores only',
  'camsregister-username-taken': 'This username is already taken',
  'camsregister-password-required': 'Password is required',
  'camsregister-password-invalid': 'Password must be at least 12 characters with uppercase, number, and symbol (!@#$*)',
  'camsregister-passwordconfirm-required': 'Please confirm your password',
  'camsregister-passwordconfirm-mismatch': 'Passwords do not match',
  'camsregister-email-required': 'Email is required',
  'camsregister-email-invalid': 'Please enter a valid email address',
  'camsregister-email-taken': 'This email is already registered',
  'camsregister-registration-failed': 'Registration failed. Please try again.',
  'camsregister-registration-success': 'Registration successful. A confirmation email has been sent. Please log in with the username and password you just set — use these credentials going forward. Redirecting to login…',
  'camsregister-session-expired': 'Your session has expired. Please login again.',
  'camsregister-username-tooltip': 'Username must be 3-30 characters and can contain letters, numbers, and underscores.',
  'camsregister-password-tooltip': 'Password must be at least 12 characters and include: uppercase letter, number, and symbol (!@#$*).',
};

export const camsLoginFr = {
  'camslogin-title': 'Connexion du titulaire de carte',
  'camslogin-subtitle':
    'Pour accéder au solde de votre carte ou pour activer votre carte, veuillez fournir les informations suivantes.',
  'camslogin-cardnumber-label': 'ENTREZ LE NUMÉRO À 16 CHIFFRES',
  'camslogin-cardnumber-placeholder': 'Numéro de carte',
  'camslogin-cvv-label': 'ENTREZ LE CVV',
  'camslogin-cvv-placeholder': 'CVV',
  'camslogin-accesscode-label': 'ENTREZ LE CODE D\'ACCÈS',
  'camslogin-accesscode-placeholder': 'Code d\'accès',
  'camslogin-submit_title': 'GO',
  'camslogin-cardnumber-errormsg':
    'Veuillez entrer un numéro de carte valide à 16 chiffres',
  'camslogin-cvv-errormsg': 'Veuillez entrer un CVV valide',
  'camslogin-accesscode-errormsg': 'Veuillez entrer un code d\'accès valide',
  'camslogin-invalid-credentials-error':
    'Identifiants de carte invalides. Veuillez vérifier vos informations et réessayer.',
  'camslogin-card-not-found-error':
    'Carte non trouvée. Veuillez vérifier votre numéro de carte.',
  'camslogin-invalid-card-error':
    'Carte non trouvée. Veuillez vérifier votre numéro de carte.',
  'camslogin-invalid-cvv-error':
    'CVV invalide. Veuillez vérifier et réessayer.',
  'camslogin-invalid-accesscode-error':
    'Code d\'accès invalide. Veuillez vérifier et réessayer.',
  'camslogin-cams-disabled-error':
    'Cette méthode de connexion n\'est pas disponible pour votre carte. Veuillez contacter le support.',
  'camslogin-already-registered-error':
    'Cette carte est déjà enregistrée avec un identifiant. Veuillez utiliser votre nom d\'utilisateur et mot de passe pour vous connecter.',
  'camslogin-cvv-helpertext': 'Le code CVV à trois chiffres est le numéro imprimé à droite de la bande de signature au verso de votre carte. Nous demandons ces chiffres pour des fins de sécurité.',
  'camslogin-accesscode-helpertext': 'Le code d\'accès est le numéro à 4 chiffres imprimé au coin droit supérieur de la lettre dont votre carte est collée.',
  'camslogin-accesscode-help-link': 'Vous n\'avez pas de code d\'accès? Cliquez ici',
  'camslogin-privacydescription':
    'Votre confidentialité et votre sécurité sont nos priorités. Gardez les détails de votre carte confidentiels pour prévenir tout accès non autorisé.',
  'camslogin-register-heading': 'Créez votre compte',
  'camslogin-register-subtitle':
    'Pour continuer à utiliser ce portail, veuillez vous inscrire avec un nom d\'utilisateur et un mot de passe. Cela rendra les connexions futures plus faciles et plus sécurisées.',
  'camslogin-register-button': 'S\'inscrire maintenant',
  'camslogin-skip-button': 'Passer pour le moment',
  'camslogin-register-username-label': 'Nom d\'utilisateur',
  'camslogin-register-username-placeholder': 'Entrez le nom d\'utilisateur',
  'camslogin-register-password-label': 'Mot de passe',
  'camslogin-register-password-placeholder': 'Entrez le mot de passe',
  'camslogin-register-confirmpassword-label': 'Confirmer le mot de passe',
  'camslogin-register-confirmpassword-placeholder': 'Confirmez votre mot de passe',
  'camslogin-register-success': 'Compte créé avec succès! Vous pouvez maintenant vous connecter avec votre nom d\'utilisateur et mot de passe.',
  'camslogin-knowledge-base': 'Base de connaissances',
  'camslogin-already-have-account': 'Vous avez déjà un nom d\'utilisateur? Connectez-vous ici',
  'camslogin-back-button': 'Retour',
  // CAMS Register
  'camsregister-title': 'Créez votre compte',
  'camsregister-subtitle': 'Pour continuer à utiliser ce portail, veuillez vous inscrire avec un nom d\'utilisateur et un mot de passe. Cela rendra les connexions futures plus faciles et plus sécurisées.',
  'camsregister-email-label': 'ADRESSE COURRIEL',
  'camsregister-email-placeholder': 'Entrez votre courriel',
  'camsregister-username-label': 'NOM D\'UTILISATEUR',
  'camsregister-username-placeholder': 'Entrez le nom d\'utilisateur',
  'camsregister-password-label': 'MOT DE PASSE',
  'camsregister-password-placeholder': 'Entrez le mot de passe',
  'camsregister-passwordconfirm-label': 'CONFIRMER LE MOT DE PASSE',
  'camsregister-passwordconfirm-placeholder': 'Confirmez votre mot de passe',
  'camsregister-submit-button': 'S\'inscrire',
  'camsregister-login-link': 'Vous avez déjà un nom d\'utilisateur? Connectez-vous ici',
  'camsregister-username-required': 'Le nom d\'utilisateur est requis',
  'camsregister-username-invalid': 'Le nom d\'utilisateur doit contenir 3 à 30 caractères avec des lettres, chiffres et tirets bas uniquement',
  'camsregister-username-taken': 'Ce nom d\'utilisateur est déjà pris',
  'camsregister-password-required': 'Le mot de passe est requis',
  'camsregister-password-invalid': 'Le mot de passe doit contenir au moins 12 caractères avec une majuscule, un chiffre et un symbole (!@#$*)',
  'camsregister-passwordconfirm-required': 'Veuillez confirmer votre mot de passe',
  'camsregister-passwordconfirm-mismatch': 'Les mots de passe ne correspondent pas',
  'camsregister-email-required': 'Le courriel est requis',
  'camsregister-email-invalid': 'Veuillez entrer une adresse courriel valide',
  'camsregister-email-taken': 'Ce courriel est déjà enregistré',
  'camsregister-registration-failed': 'L\'inscription a échoué. Veuillez réessayer.',
  'camsregister-registration-success': 'Inscription réussie. Un courriel de confirmation a été envoyé. Veuillez vous connecter avec le nom d\'utilisateur et mot de passe que vous venez de définir — utilisez ces identifiants à l\'avenir. Redirection vers la connexion…',
  'camsregister-session-expired': 'Votre session a expiré. Veuillez vous reconnecter.',
  'camsregister-username-tooltip': 'Le nom d\'utilisateur doit contenir 3 à 30 caractères et peut inclure des lettres, chiffres et tirets bas.',
  'camsregister-password-tooltip': 'Le mot de passe doit contenir au moins 12 caractères et inclure: une lettre majuscule, un chiffre et un symbole (!@#$*).',
};